import { FirmwareSummaryModel } from '@em/models/restapi/FirmwareSummary.Model';
import { CollectionModel } from '@shared/models/restapi/Collection.Model';

export class FirmwareSummaryCollectionModel extends CollectionModel<FirmwareSummaryModel> {
    public constructor() {
        super(FirmwareSummaryModel);
    }
}
